import { render, staticRenderFns } from "./searchHeadChain.vue?vue&type=template&id=1094d1b9&scoped=true"
import script from "./searchHeadChain.vue?vue&type=script&lang=js"
export * from "./searchHeadChain.vue?vue&type=script&lang=js"
import style0 from "./searchHeadChain.vue?vue&type=style&index=0&id=1094d1b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094d1b9",
  null
  
)

export default component.exports